import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { timeAgo } from '../../utils/dateTime';
// import { privatePicRequestDetailsAPI } from 'src/api/ChatApi';
import { useState, useEffect } from 'react';
import { Check, X } from 'lucide-react';
import { Card, Button } from "@mui/material";
// import { getSelectedUserDetailsAction } from 'src/containers/chat-container/actions/ChatActions';
import useSocket from '../../hooks/useSocket';
// Import any necessary actions
// import { acceptPicRequest, declinePicRequest } from '../actions/chatActions';

const PicRequest = ({ msg, userId, key }) => {
    const dispatch = useDispatch();
    const isReceiver = msg.senderId !== userId;
    const { socket } = useSocket();
    const [privatePicRequestStatus, setPrivatePicRequestStatus] = useState(msg.privatePicAccess?.status);

    useEffect(() => {
        setPrivatePicRequestStatus(msg.privatePicAccess?.status)
    }, [msg])

    // Handle accepting pic request
    const handleAccept = () => {
        if (socket) {
            socket.emit("picRequestEvent", { receiverId: msg.receiverId, targetUserId: msg.senderId, status: "Accepted" })
            setPrivatePicRequestStatus("accepted")
        }
    };
    // Handle declining pic request
    const handleDecline = () => {
        if (socket) {
            socket.emit("picRequestEvent", { receiverId: msg.receiverId, targetUserId: msg.senderId, status: "Rejected" })
            setPrivatePicRequestStatus("reject")
        }
    };
    useEffect(() => {
        const handlePrivatePicRequestAcceptDetails = async (data) => {
            // const payload = {
            //     receiverId: data.receiverId,
            //     targetUserId: data.senderId
            // }
            // const response = await privatePicRequestDetailsAPI(payload);
            // const status = response.data.data?.status?.toLowerCase();
            // if (status === "accepted" || status === "rejected") {
            //     const newStatus = status.replace("ed", "");
            //     setPrivatePicRequestStatus(newStatus);
            // }
            // else {
            //     setPrivatePicRequestStatus(status);
            // }
        }
        handlePrivatePicRequestAcceptDetails(msg);
    }, [msg]);
    useEffect(() => {
        if (socket) {
            socket.on("privatePicRequestResponse", (data) => {
                const status = data.message.status.toLowerCase();
                if (status === "accepted" || status === "rejected") {
                    const newStatus = status.replace("ed", "");
                    setPrivatePicRequestStatus(newStatus);
                    // dispatch(getSelectedUserDetailsAction({ participantId: data.message.userId }));
                    //  if(status === "accepted") 
                }
            });
        }
    }, [socket]);

    return (
        <div className="">
            {/* Case 1: Receiver with pending request - Show accept/reject buttons */}
            {privatePicRequestStatus?.toLowerCase() === "pending" && isReceiver && (
                <Card className="RequestforPrivate text-start p-4">
                    <h4 className="font-semibold mb-2">Request for Private Photos</h4>
                    <p className="text-sm text-muted-foreground mb-4">
                        Would you like to accept their request to view your private photos?
                    </p>
                    <div className="btnsforP flex gap-2">
                        {socket && <><Button className="accept bg-green-600 hover:bg-green-700" onClick={handleAccept}>Accept</Button>
                            <Button className="reject bg-red-600 hover:bg-red-700" onClick={handleDecline}>
                                Reject
                            </Button>
                        </>}
                    </div>
                </Card>
            )}
            {/* Case 2: Receiver with accepted request - Show acceptance message */}
            {privatePicRequestStatus?.toLowerCase() === "accepted" && isReceiver && (
                <Card className="RequestforPrivate text-start p-4">
                    <p className="request acceptrequest flex items-center gap-2 text-green-600">
                        <span>
                            <Check className="h-4 w-4" />
                        </span>
                        You have accepted the request. They can now view your private photos.
                    </p>
                </Card>
            )}

            {/* Case 3: Receiver with rejected request - Show rejection message */}
            {privatePicRequestStatus?.toLowerCase() === "rejected" && isReceiver && (
                <Card className="RequestforPrivate text-start p-4">
                    <p className="request rejectrequest flex items-center gap-2 text-red-600">
                        <span>
                            <X className="h-4 w-4" />
                        </span>
                        You have rejected the request. They cannot view your private photos.
                    </p>
                </Card>
            )}

            {/* Case 4: Sender with accepted request - Show acceptance message */}
            {privatePicRequestStatus?.toLowerCase() === "accepted" && !isReceiver && (
                <Card className="RequestforPrivate text-start p-4">
                    <p className="request acceptrequest flex items-center gap-2 text-green-600">
                        <span>
                            <Check className="h-4 w-4" />
                        </span>
                        Your request was accepted! You can now view their private photos.
                    </p>
                </Card>
            )}

            {/* Case 5: Sender with rejected request - Show rejection message */}
            {privatePicRequestStatus?.toLowerCase() === "rejected" && !isReceiver && (
                <Card className="RequestforPrivate text-start p-4">
                    <p className="request rejectrequest flex items-center gap-2 text-red-600">
                        <span>
                            <X className="h-4 w-4" />
                        </span>
                        Your request was rejected. You cannot view their private photos.
                    </p>
                </Card>
            )}
            {/* Case 6: Sender with pending request - Show pending message */}
            {privatePicRequestStatus?.toLowerCase() === "pending" && !isReceiver && (
                <Card className="RequestforPrivate text-start p-4">
                    <p className="text-sm text-muted-foreground">
                        You've requested to view private photos. Waiting for response...
                    </p>
                </Card>
            )}
        </div>
    );
};

export default PicRequest;
